export default "__VITE_ASSET__CIfGGeHZ__"